<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Bildbank'" :sub-title="image_name" :title-id="image_id">
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'mediabank.list' }" icon="icon-circle-left2">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <tb-skeleton v-if="busy_loading" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

            <div v-else-if="!busy_loading && image">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <ValidationObserver ref="imageform">
                                    <form @submit.prevent="saveImage">
<!--                                        <input-with-validation-->
<!--                                            vid="ImageName"-->
<!--                                            label="Namn"-->
<!--                                            rules=""-->
<!--                                            v-model="image.ImageName"-->
<!--                                        ></input-with-validation>-->
                                        <input-with-validation
                                            vid="orgfilename"
                                            label="Originalnamn"
                                            rules=""
                                            v-model="image.orgfilename"
                                            disabled
                                        ></input-with-validation>
                                        <select-with-validation
                                            vid="CatID"
                                            component="mediabank-categories-filter"
                                            v-model="image.CatID"
                                            label="Kategori"
                                            rules="required"
                                            :reduce="(opt) => opt.id"
                                        ></select-with-validation>
                                        <hr>
                                        <div>
                                            Width: {{ image.Width }} px<br>
                                            Height: {{ image.Height }} px
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex justify-content-end">
                                    <limitless-button v-if="image.ImageID > 0" ref="btndeleteimage" type="button" @click="deleteImage" :busy="busy_saving" icon="icon-cross2" btn-class="btn-danger" class="mr-auto">Radera</limitless-button>
                                    <limitless-button ref="btnsaveimage" type="button" @click="saveImage" :busy="busy_saving" icon="icon-floppy-disk">Spara</limitless-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" v-if="image.ImageID > 0">
                        <img :src="image.internal_urls.original" style="max-width: 400px; border: 1px solid #ccc;" :alt="image_name" />
                        <div>
                            <a :href="image.internal_urls.original" target="_blank">Visa original</a>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation';
import SelectWithValidation from '@components/Form/SelectWithValidation';

export default {
    name: 'MediabankImageEdit',
    components: {
        SelectWithValidation,
        InputWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        busy_translating: false,
        image: null,
        languages: [],
    }),
    mounted() {
        this.getImage();
    },
    methods: {
        getImage() {
            this.busy_loading = true;
            apiClient.get('/vue/mediabank/images/' + this.id + '')
                .then((response) => {
                    this.image = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveImage() {
            const isValid = await this.$refs.imageform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/mediabank/images/' + this.id, this.image)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.ImageID, 10)) {
                            window.location.href = '/mediabank/' + response.data.ImageID;
                        }
                        this.image = response.data;
                        this.$refs.btnsaveimage.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.imageform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveimage.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        async deleteImage() {
            let doChange = false;
            await this.$swal({
                text: 'Är du säker att du vill radera denna bild?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, ta bort!',
                cancelButtonText: 'Avbryt',
            }).then((result) => {
                if (result.isConfirmed) {
                    doChange = true;
                }
            });
            if (doChange) {
                this.busy_saving = true;
                apiClient.delete('/vue/mediabank/images/' + this.id)
                    .then(() => {
                        this.$router.push({ name: 'mediabank.list' });
                        this.busy_saving = false;
                    })
                    .catch(() => {
                        this.$refs.btndeleteimage.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
    computed: {
        image_name() {
            // eslint-disable-next-line no-nested-ternary
            return (this.image && this.image.ImageID > 0 ? (this.image.ImageName ? this.image.ImageName : this.image.orgfilename) : 'Ny bild');
        },
        image_id() {
            return (this.image && this.image.ImageID > 0 ? this.image.ImageID : '');
        },
    },
};

</script>
